module.exports = __webpack_public_path__ + "static/media/twelveV.34379ff0.png";